let instanceAlreadyExists = false;

class GoogleClassroomSetup {
  private isScriptLoaded = false;
  private isScriptLoading = false;
  private callbacks: Array<() => void> = [];

  constructor() {
    if (instanceAlreadyExists) {
      throw new Error('New GoogleClassroomSetup instance cannot be created.');
    }

    instanceAlreadyExists = true;
  }

  public loadScript(next: () => void): void {
    this.callbacks.push(next);

    if (!this.isScriptLoading) {
      if (!this.isScriptLoaded) {
        this.isScriptLoading = true;

        /* Google Classrooms requires two bits of global code loaded:
         * - A magical object that tells Google *not* to auto-render the classrooms buttons.
         * - The script that has the rendering functionality that our buttons will then call.
         * At the end of this process, there will be a `gapi` object in the global namespace, which
         * can be used to render the Classrooms buttons. See instructions for more details:
         * https://developers.google.com/classroom/guides/get-started
         */
        (window as any).___gcfg = {
          parsetags: 'explicit', // Tell Google not to auto-render the classrooms buttons.
        };
        const script = document.createElement('script');
        script.src = 'https://apis.google.com/js/platform.js';
        script.async = true;
        script.addEventListener('load', () => {
          this.isScriptLoaded = true;
          this.isScriptLoading = false;
          this.callCallbacks();
        });
        document.body.appendChild(script);
      } else {
        this.callCallbacks();
      }
    }
  }

  private callCallbacks(): void {
    this.callbacks.map(next => next());
    this.callbacks = [];
  }
}

export const googleClassroomSetup = new GoogleClassroomSetup();
